import React, { useState, useEffect, useRef } from 'react';

import useTable from "../useTable";

import axios from 'axios';
import { ActualizarClassPresupuestaria } from './modalActualizarClassPuc';
import { ClassxArchivotxt } from './modalClassXarchivo';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';


const TablaClasificadorPresupuestario = (props) => {

  var op = require('../../../src/modulos/datos')
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
  let municipios = [];

  const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'PARTIDA', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]


  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [puc, setPuc] = useState();
  const txtBuscador = useRef()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    setFilterFn({


      fn: items => {
        if (target.value === "") {
          return items;
        } else {
          const lowerCaseTarget = target.value.toLowerCase();

          // Filtra por numdoc primero
          let filteredItems = items.filter(x => x.puc.includes(target.value));

          // Si no hay coincidencias en numdoc, busca en los otros campos
          if (filteredItems.length === 0) {
            filteredItems = items.filter(x =>


              (x.descripcion !== '' && x.descripcion.toLowerCase().includes(lowerCaseTarget)) ||
              (x.idpuc !== '' && x.idpuc.toLowerCase().includes(lowerCaseTarget))

            );
          }

          return filteredItems;
        }
      }
    })

  }

  const SeleccionarRegistros = () => {

    setActivate(true);

    let endpoint = `${op.conexion}/api/administracion/partida?idefiscal=${idefiscal}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        setRecords(response.data);
        txtBuscador.current.focus()
      }

    }).catch(function (error) {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

    }).finally(function () {
      setActivate(false);
    });
  }

  const SelecccionarPuc = (id) => {

    setActivate(true);

    let campos = "*"
    let nomtab = "puc";
    let nomid = "idpuc";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {

      if (response.status == 200) {

        if (response.data.idpuc > 0) {
          setPuc(response.data);
          setMostrar2(true);
        } else {
          setPuc()
          setMostrar2(true);
        }
        setActivate(false);
      }

    }).catch((error) => {

      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);

    })
  }


  const handleCloseSi = () => {

    setActivate(false);

  };

  const gestionarActuProgramatica = (op, id) => (e) => {

    if (op === 4) {
      setOperacion(4);
      SelecccionarPuc(id, op);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true)
    } else if (op === 2) {
      setOperacion(op);
      SelecccionarPuc(id, op);
    } else if (op === 3) {
      setOperacion(op);
      SelecccionarPuc(id, op);
    }

  }


  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  }

  const handleCancelara = () => {
    setMostrar3(false);
  }

  const cerrar = () => {
    props.menu()
  }

  return (
    <section className='modal-azulGradiant mx-auto col-9'>
      <header className='header-azulGradiant'>
        <h3 >
          Clasificador Presupuestario
        </h3>
        <a type='button' onClick={cerrar}>
          salir<i className="fas fa-times"></i>
        </a>
      </header>
      <div className="form-azulGradiant px-2">
        <input type="text" className="search-input  col-3 form-control text-uppercase form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />
        <button onClick={gestionarActuProgramatica(1, '')} style={{ marginBottom: "5px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>

      </div>
      <div className="col-md-12 m-0" >
            <TblContainer>
              <TblHead />
              <tbody>
                {
                  records && recordsAfterPagingAndSorting().map((item, index) => (
                    <tr key={index} style={{ padding: "0" }}>
                      <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '100px' }}>{item.puc}</td>
                      <td className='align-middle' style={{ textAlign: "left", alignItems: 'center', width: '300px' }}>{item.descripcion}</td>
                      <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>{item.idpuc}</td>
                      <td className='align-middle' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>
                        <button onClick={gestionarActuProgramatica(4, item.idpuc)} className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i> </button>
                        <button onClick={gestionarActuProgramatica(2, item.idpuc)} className="btn btn-sm mx-1 btn-warning rounded-circle"><i className="fa fa-edit"></i> </button>
                        <button onClick={gestionarActuProgramatica(3, item.idpuc)} className="btn btn-sm mx-1 btn-danger rounded-circle"><i className="fa fa-trash"></i> </button>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </TblContainer>
            <TblPagination />
          </div>
      <ActualizarClassPresupuestaria
        show={mostrar2}
        operacion={operacion}
        puc={puc}
        onHideCancelar={handleCancelar}
        onHideRenderizar={SeleccionarRegistros}
      />
      <ClassxArchivotxt
        show={mostrar3}
        operacion={operacion}
        onHideCancelar={handleCancelara}
        onHideRenderizar={SeleccionarRegistros}
      />

      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

      <Dimmer active={activate} inverted>
      </Dimmer>

    </section>
  );
}
export default TablaClasificadorPresupuestario;